module.exports = __webpack_public_path__ + "img/NGN.c7e555d7.svg";